import * as L from 'leaflet';
import {
  ParamsCreatePolylineDecorator,
  ResponseCreatePolylineDecorator,
} from '../models/manager-leaflet.model';
import { COLOR_HISTORY } from 'src/app/historial/static/color-elements.static';

export const DEFAULT_OPTIONS: L.PolylineDecoratorOptions = {
  patterns: [
    {
      offset: 25, // Comenzar a 25px del inicio
      repeat: 70, // Repetir cada 70px (más espaciado para evitar sobrecarga visual)
      endOffset: 25, // Terminar 25px antes del final
      symbol: L.Symbol.arrowHead({
        pixelSize: 10, // Tamaño más pequeño para mejor consistencia en curvas
        polygon: true, // Usar polígono relleno para mejor estabilidad visual
        pathOptions: {
          stroke: true,
          color: COLOR_HISTORY.ROUTE_COLOR, // Color del borde
          weight: 1.5, // Borde ligeramente más fino
          opacity: 1,
          fill: true, // Activar relleno
          fillColor: COLOR_HISTORY.ROUTE_COLOR, // Mismo color para el relleno
          fillOpacity: 1,
          interactive: false, // No interactivo
        },
      }),
    },
  ],
};

export function createPolylineDecorator(
  params: ParamsCreatePolylineDecorator
): ResponseCreatePolylineDecorator {
  try {
    // VALIDACIONES
    if (!params.polyline) {
      return {
        polylineDecorator: null,
        error: 'No se proporcionó el polyline',
      };
    }

    const options: L.PolylineDecoratorOptions = {
      ...DEFAULT_OPTIONS,
      ...(params.options ?? {}),
      // interactive: false,
    };

    // CREAR EL POLYLINE
    const polylineDecorator = L.polylineDecorator(params.polyline, options);
    if (!polylineDecorator) {
      return {
        polylineDecorator: null,
        error: 'No se pudo crear el polyline',
      };
    }
    return { polylineDecorator, error: null };
  } catch (error) {
    return {
      polylineDecorator: null,
      error: 'Error desconocido al crear polyline',
    };
  }
}
